import { useIntl } from 'react-intl'
import PriceDetails from 'tripPlanner/components/ItemOfferPrice/PriceDetails'

interface Props {
  view: App.ExperienceBookingView
  currencyCode: string
}
function ExperienceBookmarkCardPriceDetails({
  view,
  currencyCode,
}: Props) {
  const intl = useIntl()
  return (
    <PriceDetails
      price={view.price}
      discount={0}
      priceLabel={intl.formatMessage({
        id: 'SMZiwM0CB9T-HQ4Bimpi',
        defaultMessage: 'From',
        description: 'Price label prefix meaning "starting from" on experience bookmark card',
      })}
      totalLabel=""
      discountDisplayType="none"
      currencyCode={currencyCode}
    />
  )
}

export default ExperienceBookmarkCardPriceDetails
